var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'fixed': _vm.showSideBar},attrs:{"id":"app"}},[_c('toast-notification'),_c('transition',{attrs:{"name":"page-fade-up","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }